import type { ReactNode } from 'react';
import { bankTransactionIncomeExpenseTypeLabels } from './bankTransactionIncomeExpenseTypeLabels';

type BankTransactionIncomeExpenseTypeCellProps = {
  value: unknown;
};

export const BankTransactionIncomeExpenseTypeCell = ({
  value,
}: BankTransactionIncomeExpenseTypeCellProps): ReactNode => {
  const numericValue = Number(value);

  return bankTransactionIncomeExpenseTypeLabels[numericValue] ?? String(value ?? '');
};
